import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Pagination, CircularProgress, Button } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import {
  TextField,
  InputAdornment,
  Modal,
  Box,
  Typography,
} from '@mui/material';
import { Delete, Cancel } from '@mui/icons-material';

import TDataGrid from '../../../components/Datagrid/Datagrid';
import PermissionToRender from '../../../components/Permission/PermissionToRender';
import ConfirmationModal from '../../../components/Modal';
import CustomInput from '../../../components/CustomInput';
import { columns as Columns } from './constants/table_columns_data';
import * as DEFAULT from './constants/list.default';
import service from './service';
import { useBoundStore } from '../../../stores';
const boxStyle = {
  outline: 'none',
  position: 'absolute',
  top: '50%',
  left: '50%',
  borderRadius: 30,
  transform: 'translate(-50%, -50%)',
  width: 937,
  height: 'auto',
  backgroundColor: 'white',
  boxShadow: 24,
  padding: 30,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

const Users = () => {
  const location = useLocation();

  // const [instance, setInstance] = useState(
  //   JSON.parse(localStorage.getItem('selectedInstance'))
  //     ? JSON.parse(localStorage.getItem('selectedInstance'))[0].id
  //     : JSON.parse(localStorage.getItem('instance'))[0].instance.id,
  // );
  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);

  const [modalOpen, setModalOpen] = useState(false);
  const [createFormData, setCreateFormData] = useState({
    firstname: '',
    lastname: '',
    userId: '',
    userRole: '',
  });

  const [filterData, setFilterData] = useState({ param: '' });
  const [sortModel, setSortModel] = useState(DEFAULT.SORT_MODEL);
  const [isLoading, setIsLoading] = useState(DEFAULT.IS_LOADING);
  const [page, setPage] = useState(DEFAULT.PAGE);
  const [users, setUsers] = useState(DEFAULT.USERS);
  const [count, setCount] = useState(DEFAULT.COUNT);

  const paginationChange = (_, e_page) => setPage(e_page - 1);

  const [open, setOpen] = useState(false);
  const [row, setRow] = useState([]);

  const handleDelete = async (row) => {
    setRow(row);
    setOpen(true);
  };

  const columns = Columns(handleDelete);

  const getData = async () => {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const payload = {
      ...filterData,
      size: 10,
      page: page,
      sort: `${field},${sort}`,
    };
    const result = await service.getUserWithSearch(payload);
    const data = result?.data?.content || [];
    setCount(result?.data?.totalPages);
    setUsers(data);
    setIsLoading(false);
  };

  const deleteUser = async () => {
    const result = await service.deleteUser({
      userId: row.id,
    });
    if (result?.status === 200) {
      setOpen(false);
      toast.success('Kullanıcı başarıyla silindi.');
      getData();
    } else {
      setOpen(false);
      toast.error('Kullanıcı silinirken bir hata oluştu.');
    }
  };

  const handleFilterInput = (newValue) => {
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      param: newValue,
    }));
  };

  useEffect(() => {
    setPage(0);
    getData();
  }, [filterData]);

  const filter = async () => {
    setPage(0);
    getData();
  };

  useEffect(() => {
    getData();
  }, [page, sortModel, location]);

  return (
    <div className="p-3 m-3 flex flex-col justify-center items-center">
      <div className="w-max max-lg:w-full p-3 m-3">
        <div className=" py-3 px-2 mx-3 my-2 flex flex-wrap justify-between max-sm:justify-center gap-3 items-center">
          <span className="text-lg sm:text-2xl max-sm:text-center">
            Kullanıcılar
          </span>
          <div className="mx-2 my-5 flex justify-between items-center">
            <div className="flex gap-3">
              <TextField
                size="small"
                placeholder="Arama"
                onChange={(e) => handleFilterInput(e.target.value)}
                value={filterData.param}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MATERIEL_ICONS.Search />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: '8px',
                  },
                }}
              />
              {/* <PermissionToRender roleCanView={'KV_SUPERUSER'}> */}
              <Button
                variant="contained"
                color="primary"
                startIcon={<MATERIEL_ICONS.Add />}
                onClick={() => toggleRightDrawer()}
                className="mx-2"
              >
                Kullanıcı Ekle
              </Button>
              {/* </PermissionToRender> */}
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className="flex justify-center items-center w-[914px]">
            <CircularProgress className="users-list-circular-progress" />
          </div>
        ) : (
          <div className="w-max max-lg:w-full bg-white rounded-xl shadow-xl p-3 m-3">
            <TDataGrid
              rows={users}
              columns={columns}
              sortModel={sortModel}
              setSortModel={setSortModel}
            />
            <div className="flex justify-center items-center p-3 m-3">
              <Pagination
                page={page + 1}
                onChange={paginationChange}
                count={count}
                color="primary"
                size="small"
              />
            </div>
          </div>
        )}
      </div>
      <ConfirmationModal
        img="warning"
        open={open}
        handleClose={() => setOpen(false)}
        title={`${row.name} ${row.surname} adlı kullanıcıyı silmek üzeresiniz.`}
        onConfirm={deleteUser}
        confirmText="SİL"
        cancelText="İPTAL"
        confirmStartIcon={<Delete />}
        cancelStartIcon={<Cancel />}
        text="Bu işlem geri alınamaz. Devam etmek istediğinize emin misiniz?"
      />
    </div>
  );
};

export default Users;

{
  /* <Modal
open={modalOpen}
onClose={() => setModalOpen(false)}
>
<Box style={boxStyle}>
  <div className='mt-5'>

    <div>
      <Typography
        variant="h5"
        color="initial"
        gutterBottom
        textAlign={'center'}
      >
        Yeni Kullanıcı Ekle
      </Typography>
    </div>

    <div className="flex flex-row flex-wrap items-center gap-3 w-full my-5 ">
      {fields().map((field, index) => {
        return (
          <div className=" flex  flex-wrap h-20" key={index}>
            <CustomInput
              key={index}
              type={field.type}
              items={field.items}
              label={field.placeHolder}
              value={createFormData[field.key]}
              fullWidth={false}
              size={'medium'}
              sx={{ width: '284px' }}
              onChange={(key, value) => {
                setCreateFormData({
                  ...createFormData,
                  [field.key]: value,
                });
              }}
            />
          </div>
        );
      })}
    </div>
    <div className='flex justify-between items-center'>
      <div className=' '>
        Kullanıcı {instances.find((ins) => ins.id === instance).name} uygulamasına ekleniyor.
      </div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          console.log(
            {
              yerlemId: createFormData.userId,
              appInstance: instance,
              email: createFormData.userId + '@yerlem.com',
              gsm: createFormData.userId,
              password: createFormData.userId,
              twoFactorAuthenticaton: false,
              userRole: createFormData.userRole,
              firstname: createFormData.firstname,
              lastname: createFormData.lastname,
            }
          );
        }}
        startIcon={<MATERIEL_ICONS.Save />}
      >
        Kaydet
      </Button>
    </div>
  </div>
</Box>
</Modal> */
}
